import React from 'react'
import { useForm, UseFormReturn, FieldValues, SubmitHandler } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

interface FormWrapperProps<T extends FieldValues> {
  schema: z.ZodSchema<T>
  defaultValues?: Partial<T>
  onSubmit: SubmitHandler<T>
  children: (methods: UseFormReturn<T>) => React.ReactNode
  className?: string
}

export function FormWrapper<T extends FieldValues>({
  schema,
  defaultValues,
  onSubmit,
  children,
  className
}: FormWrapperProps<T>) {
  const methods = useForm<T>({
    resolver: zodResolver(schema),
    defaultValues: defaultValues as any,
    mode: 'onChange'
  })

  const handleSubmit = methods.handleSubmit(onSubmit)

  return (
    <form 
      onSubmit={handleSubmit} 
      className={className}
      noValidate
    >
      <div className="space-y-6">
        {children(methods)}
      </div>
    </form>
  )
}

export default FormWrapper